"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var BrowserLifecycle = (function (_super) {
    __extends(BrowserLifecycle, _super);
    function BrowserLifecycle(player) {
        var _this = _super.call(this) || this;
        _this.player = player;
        _this.requestFullscreen = function () {
            if (!document.fullscreen) {
                _this.player.getRootElement().requestFullscreen();
                return true;
            }
            return false;
        };
        _this.exitFullscreen = function () {
            if (document.fullscreen) {
                document.exitFullscreen();
                return true;
            }
            return false;
        };
        _this.fullscreenChangedHandler = [];
        return _this;
    }
    BrowserLifecycle.prototype.onExiting = function (handler) {
        this.fullscreenChangedHandler.forEach(function (fullscreenChangedHandler) { return document.removeEventListener('fullscreenchange', fullscreenChangedHandler); });
        return true;
    };
    BrowserLifecycle.prototype.onFullscreenChanged = function (handler) {
        var fullscreenChangedHandler = function () {
            handler(document.fullscreen);
        };
        document.addEventListener('fullscreenchange', fullscreenChangedHandler);
        this.fullscreenChangedHandler.push(fullscreenChangedHandler);
        return true;
    };
    BrowserLifecycle.prototype.setFullscreen = function (isFullscreen) {
        return isFullscreen ? this.requestFullscreen() : this.exitFullscreen();
    };
    return BrowserLifecycle;
}(client_lib_js_player_addons_common_player_1.Lifecycle));
exports.BrowserLifecycle = BrowserLifecycle;
